export const SET_CONTRACT_ID = "SET_CONTRACT_ID";
export const SET_SCREEN = "SET_SCREEN";
export const SET_PROCESSING = "SET_PROCESSING";
export const SET_CONTRACT = "SET_CONTRACT";
export const SET_CONTACT = "SET_CONTACT";
export const SET_TERMS_URL = "SET_TERMS_URL";
export const SET_PERSONALDATA_URL = "SET_PERSONALDATA_URL";
